/* eslint-disable */
import React, { Component, useState } from 'react';
import { Link, Redirect } from 'react-router-dom';
import api from '../../services/api';
import {Container, Atencao, Filtro, DivAccordion, DivAlphabet} from './styles';
import Alerta from '../../assets/icones/icon_alert-triangle.svg';
import {FiChevronDown} from 'react-icons/fi';
import {Switch} from 'antd';
import CurrencyInput from 'react-currency-input';
import Entrega from '../../assets/emojis/entrega/entrega@3x.png';
import Modal from 'react-modal';
import BairroModal from './modalBairro';
import FiltroModal from './modalFiltro';
import { uniqueId } from 'lodash';
import ModalSelect from './modalSelect';
import Collapse from "@kunukn/react-collapse";
import { toast, Slide, ToastContainer } from 'react-toastify';
import '../../css/ReactToastify.css';
import { IoMdCloseCircle, IoMdCheckmarkCircle } from 'react-icons/io';

const entrada = {
    overlay: {
        position: 'fixed',
        zIndex: 21,
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: 'rgba(0, 0, 0, 0.03)',
      },
      content: {
        borderWidth: '0px',
        borderRadius: '8px',
        padding: '0px',
        position: 'fixed',
        top: '50%',
        left: '50%',
        transform: 'translate(-140%, -50%)',
        width: '100%',
        maxWidth: '322px',
        height: '100%',
        maxHeight: '256px'
      }
  };

const mobile = {
    overlay: {
        position: 'fixed',
        zIndex: 21,
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: 'rgba(0, 0, 0, 0.2)',
      },
      content: {
        borderWidth: '0px',
        borderRadius: '8px',
        padding: '0px',
        position: 'fixed',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -42%)',
        width: '100%',
        maxWidth: '360px',
        height: '85%',
      }
  };

const customStyles = {
    overlay: {
        position: 'fixed',
        zIndex: 20,
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: 'rgba(0, 0, 0, 0.2)',
      },
      content: {
        borderRadius: '8px',
        padding: '0px',
        position: 'fixed',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        width: '100%',
        maxWidth: '969px',
        height: '100%',
        maxHeight: '536px'
      }
  };

  const filtroStyles = {
    overlay: {
        position: 'fixed',
        zIndex: 20,
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: 'rgba(0, 0, 0, 0.2)',
      },
      content: {
        borderRadius: '8px',
        padding: '0px',
        position: 'fixed',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        width: '100%',
        maxWidth: '969px',
        height: '100%',
        maxHeight: '360px'
      }
  };

  const filtroStylesMob = {
    overlay: {
        position: 'fixed',
        zIndex: 20,
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: 'rgba(0, 0, 0, 0.2)',
      },
      content: {
        borderRadius: '8px',
        padding: '0px',
        position: 'fixed',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        width: '100%',
        maxWidth: '969px',
        height: '100%',
      }
  };

export default class TempoEntrega extends Component {
    constructor(props) {
        super(props);
        this.state = {
            redirect: false,
            isOpen: false,
            selectOpen: false,
            carregou: false,
            alerta: false,
            selected: 0,
            token: '',
            rest: {},
            tipo: 0,
            prevTipo: 0,
            valorClass1: 'div-input',
            valorClass2: 'div-input',
            valor1: '0.00',
            valor2: '0.00',
            entrega_gratis: false,
            bairros: [],
            restBairros: [],
            idBairro: 0,
            letraBairro: '',
            valorBairro: 0,
            km: [],
            windowWidth: window.innerWidth,
            filtro: 0,
            filtroOpen: false,
            superUser: false,
            permission: null,
            saved: false,
            idDistancia: null,
        }
    }

    handleResize = (e) => {
        this.setState({ windowWidth: window.innerWidth });
    }

    success = () => {
        toast.dismiss();
        const ToastSuccess = () => (
            <div style={{
                display: 'flex',
                alignItems: 'center',
                flexDirection: 'row',
                justifyContent: 'center'
            }}>
                <div>
                    <IoMdCheckmarkCircle color="#51db74" size={28}/>
                </div>
                <div style={{ paddingLeft: 16 }}>
                    <span style={{
                        fontFamily: 'Montserrat',
                        color: "#5b8e3e",
                        fontSize: 16,
                        textAlign: 'center'
                    }}>As alterações foram salvas com sucesso.</span>
                </div>
            </div>
        );
        toast.success(<ToastSuccess />, {
            position: toast.POSITION.BOTTOM_CENTER,
            hideProgressBar: true,
            autoClose: 8000,
            closeButton: false,
            pauseOnHover: false,
            transition: Slide,
        });
    }
    error = () => {
        toast.dismiss();
        const ToastError = () => (
            <div style={{
                display: 'flex',
                alignItems: 'center',
                flexDirection: 'row',
                justifyContent: 'center'
            }}>
                <div>
                    <IoMdCloseCircle color="#d2252e" size={28}/>
                </div>
                <div style={{ paddingLeft: 16 }}>
                    <span style={{
                        fontFamily: 'Montserrat',
                        color: "#983236",
                        fontSize: 16,
                        textAlign: 'center'
                    }}>Ocorreu um erro. Tente novamente mais tarde.</span>
                </div>
            </div>
        );
        toast.error(<ToastError />, {
            position: toast.POSITION.BOTTOM_CENTER,
            hideProgressBar: true,
            autoClose: 8000,
            closeButton: false,
            pauseOnHover: false,
            transition: Slide
        });
    }

    customError = (text) => {
        toast.dismiss();
        const ToastError = () => (
            <div style={{
                display: 'flex',
                alignItems: 'center',
                flexDirection: 'row',
                justifyContent: 'center'
            }}>
                <div>
                    <IoMdCloseCircle color="#d2252e" size={28}/>
                </div>
                <div style={{ paddingLeft: 16 }}>
                    <span style={{
                        fontFamily: 'Montserrat',
                        color: "#983236",
                        fontSize: 16,
                        textAlign: 'center'
                    }}>{text}</span>
                </div>
            </div>
        );
        toast.error(<ToastError />, {
            position: toast.POSITION.BOTTOM_CENTER,
            hideProgressBar: true,
            autoClose: 8000,
            closeButton: false,
            pauseOnHover: false,
            transition: Slide
        });
    }

    async componentDidMount() {
        let componentDidMount_super = CurrencyInput.prototype.componentDidMount;
        CurrencyInput.prototype.componentDidMount = function() {
            if(!this.props.autoFocus) {
                let setSelectionRange_super = this.theInput.setSelectionRange;
                this.theInput.setSelectionRange = () => {};
                componentDidMount_super.call(this, ...arguments);
                this.theInput.setSelectionRange = setSelectionRange_super;
            }
            else {
                componentDidMount_super.call(this, ...arguments);
            }
        };
        let componentDidUpdate_super = CurrencyInput.prototype.componentDidUpdate;
        CurrencyInput.prototype.componentDidUpdate = function() {
            if(!this.props.autoFocus) {
                let setSelectionRange_super = this.theInput.setSelectionRange;
                this.theInput.setSelectionRange = () => {};
                componentDidUpdate_super.call(this, ...arguments);
                this.theInput.setSelectionRange = setSelectionRange_super;
            }
            else {
                componentDidMount_super.call(this, ...arguments);
            }
        };
        toast.configure();
        Modal.setAppElement('body');
        window.addEventListener("resize", this.handleResize)
        const token = await localStorage.getItem('@jwt');
        const isSuser = await localStorage.getItem('@internal');
        const rest = await JSON.parse(localStorage.getItem('@rest'));
        this.setState({ token: token, rest });
        if(isSuser) {
            const permissions = await JSON.parse(localStorage.getItem('@suser'));
            this.setState({superUser: true, permission: permissions.configuracoes})
        }
        if(this.state.superUser) {
            if(this.state.permission !== 0) {
                await this.getRestInfo().then(() => {
                    this.getBairros();
                    this.getDistancia();
                    this.setState({carregou: true});
                })
            }
        } else {
            await this.getRestInfo().then(() => {
                this.getBairros();
                this.getDistancia();
                this.setState({carregou: true});
            })
        }
    }

    componentWillUnmount() {
        window.addEventListener("resize", this.handleResize)
    }

    async getDistancia() {
        try {
            await api.get('api/restauranteconfigs/taxasdistancias', {
                headers: {
                    Authorization: `Bearer ${this.state.token}`
                }
            }).then(res => {
                this.setState({
                    km: res.data.taxas
                })
            }).catch(async e => {
                if (e.response.status === 401) {
                    try {
                        await localStorage.removeItem('@username');
                        await localStorage.removeItem('@jwt');
                        await localStorage.removeItem('@user');
                        await localStorage.removeItem('@rest');
                        await localStorage.removeItem('@uf');
                        await localStorage.removeItem('@internal');
                        await localStorage.removeItem('@suser');
                        this.setState({
                            redirect: true
                        })
                    } catch (e) {
                        console.log(e.data);
                    }
                }
            })
        } catch (error) {
            console.log(error);
        }
    }

    async getRestInfo() {
        try {
            await api.get('api/restaurantepagina/informacoesRestaurante', {
                headers: {
                    Authorization: `Bearer ${this.state.token}`
                }
            }).then(res => {
                this.setState({
                    valor1: res.data.infos.taxa_entrega,
                    valor2: res.data.infos.taxa_entrega_limite === null ? '0.00' : res.data.infos.taxa_entrega_limite,
                    entrega_gratis: res.data.infos.taxa_entrega_limite === null ? false : true
                })
                if (res.data.infos.taxa_entrega === '0.00' && res.data.infos.tipo_entrega === '1') {
                    this.setState({
                        tipo: 1,
                    })
                }
                if (res.data.infos.taxa_entrega !== '0.00' && res.data.infos.tipo_entrega === '1') {
                    this.setState({
                        tipo: 2,
                    })
                }
                if (res.data.infos.tipo_entrega === '2') {
                    this.setState({
                        tipo: 3,
                    })
                }
                if (res.data.infos.tipo_entrega === '3') {
                    this.setState({
                        tipo: 4,
                    })
                }
            }).catch(async e => {
                if (e.response.status === 401) {
                    try {
                        await localStorage.removeItem('@username');
                                await localStorage.removeItem('@jwt');
                                await localStorage.removeItem('@user');
                                await localStorage.removeItem('@rest');
                                await localStorage.removeItem('@uf');
                                await localStorage.removeItem('@internal');
                                await localStorage.removeItem('@suser');
                        this.setState({
                            redirect: true
                        })
                    } catch (e) {
                        console.log(e.data);
                    }
                }
            })
        } catch (error) {
            console.log(error);
        }
    }

    removeAcento (text) {                                               
        text = text.replace(new RegExp('[ÁÀÂÃ]','gi'), 'a');
        text = text.replace(new RegExp('[ÉÈÊ]','gi'), 'e');
        text = text.replace(new RegExp('[ÍÌÎ]','gi'), 'i');
        text = text.replace(new RegExp('[ÓÒÔÕ]','gi'), 'o');
        text = text.replace(new RegExp('[ÚÙÛ]','gi'), 'u');
        text = text.replace(new RegExp('[Ç]','gi'), 'c');
        return text.toUpperCase();                 
    }

    async getRestBairros() {
        if (!!this.state.restBairros.length) {
            return null;
        } else {
            try {
                await api.get('api/restauranteconfigs/restbairros', {
                    headers: {
                        Authorization: `Bearer ${this.state.token}`
                    }
                }).then(res => {
                    this.setState({ restBairros: res.data.existentes });
                }).catch(async e => {
                    if (e.response.status === 401) {
                        try {
                            await localStorage.removeItem('@username');
                                await localStorage.removeItem('@jwt');
                                await localStorage.removeItem('@user');
                                await localStorage.removeItem('@rest');
                                await localStorage.removeItem('@uf');
                                await localStorage.removeItem('@internal');
                                await localStorage.removeItem('@suser');
                            this.setState({
                                redirect: true
                            })
                        } catch (e) {
                            console.log(e.data);
                        }
                    }
                })
            } catch (error) {
                console.log(error);
            }
        }
    }

    async getBairros() {
        if (!!this.state.bairros.length) {
            return null
        } else {
            try {
                await api.get('api/restauranteconfigs/bairros', {
                    headers: {
                        Authorization: `Bearer ${this.state.token}`
                    }
                }).then(res => {
                    this.getRestBairros().then(() => {
                        let result = [];
                        const {restBairros} = this.state;
                        const response = res.data;
                        for (let i = 0; i < response.length; i++) {
                            result.push({id: response[i].id, nome: response[i].nome, ativo: false, valor: Number('0.00').toFixed(2)})
                            for (let j = 0; j < restBairros.length; j++) {
                                if (restBairros[j].bairro_id === response[i].id) {
                                    result.splice(i, 1);
                                    result.push({id: response[i].id, nome: response[i].nome, ativo: true, valor: Number(restBairros[j].valor).toFixed(2)})
                                }
                            }
                        }
                        result.sort((a, b) => a.nome.localeCompare(b.nome, 'es', { sensitivity: 'base' }))
                        let data = result.reduce((r, e) => {
                            // get first letter of name of current element
                            let alphabet = this.removeAcento(e.nome[0]);
                            // if there is no property in accumulator with this letter create it
                            if (!r[alphabet]) r[alphabet] = { alphabet, record: [e] }
                            // if there is push current element to children array for that letter
                            else r[alphabet].record.push(e);
                            // return accumulator
                            return r;
                        }, {});
                        let bairros = Object.values(data);
                        this.setState({bairros})
                    })
                }).catch(async e => {
                    if (e.response.status === 401) {
                        try {
                            await localStorage.removeItem('@username');
                                await localStorage.removeItem('@jwt');
                                await localStorage.removeItem('@user');
                                await localStorage.removeItem('@rest');
                                await localStorage.removeItem('@uf');
                                await localStorage.removeItem('@internal');
                                await localStorage.removeItem('@suser');
                            this.setState({
                                redirect: true
                            })
                        } catch (e) {
                            console.log(e.data);
                        }
                    }
                })
            } catch (error) {
                console.log(error);
            }
        }
    }

    handleInputs(event) {
        switch (event.target.name) {
            case 'valor1':
                var valor1 = event.target.value;
                var formatValue1 = valor1.split(' ');
                var formated1 = formatValue1[1]?.replace(/,/g, '.');
                this.setState({
                    valor1: Number(formated1).toFixed(2)
                });
                break;
            case 'valor2':
                var valor2 = event.target.value;
                var formatValue2 = valor2.split(' ');
                var formated2 = formatValue2[1]?.replace(/,/g, '.');
                this.setState({
                    valor2: Number(formated2).toFixed(2)
                });
                break;
            default:
                break;
        }
        this.setState({ saved: true })
    }

    handleSwitch(item, item2) {
        let {bairros} = this.state;
        for (let i = 0; i < bairros.length; i++) {
            if (item.alphabet === bairros[i].alphabet) {
                for (let j = 0; j < bairros[i].record.length; j++) {
                    if (bairros[i].record[j].nome === item2.nome) {
                        bairros[i].record[j].ativo = !item2.ativo;
                    }
                }
            }
        }
        this.setState({ bairros, saved: true });
    }

    handleModalBairro(estado, id, letra, valor) {
        this.setState({ idBairro: id, letraBairro: letra, valorBairro: valor });
        this.controllerModal(estado);
    }

    controllerModal(estado){
        this.setState({
            isOpen: !estado
        });
      }

      filtroModal(estado){
        this.setState({
            filtroOpen: !estado
        });
      }

      selectModal(estado){
        this.setState({
            selectOpen: !estado
        });
      }

    setValorBairro(id, letra, valor) {
        let {bairros} = this.state;
        try {
            for (let i = 0; i < bairros.length; i++) {
                if (bairros[i].alphabet === letra) {
                    for (let j = 0; j < bairros[i].record.length; j++) {
                        if (bairros[i].record[j].id === id) {
                            bairros[i].record[j].valor = valor;
                        }
                    }
                }
            }
            this.controllerModal(this.state.isOpen);
            this.setState({ saved: true });
        } catch (error) {
            console.log(error);
        }
    }

    async postBairros() {
        try {
            let novos = [];
            const {bairros} = this.state;
            for (let i = 0; i < bairros.length; i++) {
                for (let j = 0; j < bairros[i].record.length; j++) {
                    if (bairros[i].record[j].ativo === true) {
                        novos.push(bairros[i].record[j])
                    }
                }
            }
            await api.post('api/restauranteconfigs/selectbairros', {
                ativarBairros: novos,
            }, {
                    headers: {
                    Authorization: `Bearer ${this.state.token}`
                }
            }).then(res => {
                this.success();
            }).catch(async e => {
                this.error();
                if (e.response.status === 401) {
                    try {
                        await localStorage.removeItem('@username');
                                await localStorage.removeItem('@jwt');
                                await localStorage.removeItem('@user');
                                await localStorage.removeItem('@rest');
                                await localStorage.removeItem('@uf');
                                await localStorage.removeItem('@internal');
                                await localStorage.removeItem('@suser');
                        this.setState({
                            redirect: true
                        })
                    } catch (e) {
                        console.log(e.data);
                    }
                }
            })
        } catch (error) {
            console.log(error);
        }
    }

    async postTipoEntrega() {
        let tipo = '';
        switch (this.state.tipo) {
            case 1:
                tipo = 'gratis';
                break;
            case 2:
                tipo = 'fixa';
                break;
            case 3:
                tipo = 'bairro';
                break;
            case 4:
                tipo = 'distancia';
                break;  
            default:
                break;
        }
        try {
            await api.put('api/restauranteconfigs/tipoentrega', {
                tipo_entrega: tipo
            }, {
                headers: {
                    Authorization: `Bearer ${this.state.token}`
                }
            }).then(res => {
                if (tipo === 'gratis') {
                    this.setState({ saved: false });
                    this.success();
                }
            }).catch(async e => {
                this.error();
                if (e.response.status === 401) {
                    try {
                        await localStorage.removeItem('@username');
                                await localStorage.removeItem('@jwt');
                                await localStorage.removeItem('@user');
                                await localStorage.removeItem('@rest');
                                await localStorage.removeItem('@uf');
                                await localStorage.removeItem('@internal');
                                await localStorage.removeItem('@suser');
                        this.setState({
                            redirect: true
                        })
                    } catch (e) {
                        console.log(e.data);
                    }
                }
            })
        } catch (error) {
            console.log(error);
        }
    }

    async postLimite() {
        const limite = this.state.entrega_gratis;
        const valor = String(this.state.valor2);
        try {
            await api.put('api/restauranteconfigs/taxalimite', {
                limite: limite ? valor : null
            }, {
                headers: {
                    Authorization: `Bearer ${this.state.token}`
                }
            }).then(res => {
                this.success();
                this.setState({ saved: false });
            }).catch(async e => {
                this.error();
                if (e.response.status === 401) {
                    try {
                        await localStorage.removeItem('@username');
                                await localStorage.removeItem('@jwt');
                                await localStorage.removeItem('@user');
                                await localStorage.removeItem('@rest');
                                await localStorage.removeItem('@uf');
                                await localStorage.removeItem('@internal');
                                await localStorage.removeItem('@suser');
                        this.setState({
                            redirect: true
                        })
                    } catch (e) {
                        console.log(e.data);
                    }
                }
            })
        } catch (error) {
            console.log(error);
        }
    }

    async postFixa() {
        const taxaValor = String(this.state.valor1);
        try {
            await api.put('api/restauranteconfigs/taxafixa', {
                taxa_entrega: taxaValor
            }, {
                headers: {
                    Authorization: `Bearer ${this.state.token}`
                }
            }).then(res => {
                this.postLimite();
            }).catch(async e => {
                this.error();
                if (e.response.status === 401) {
                    try {
                        await localStorage.removeItem('@username');
                                await localStorage.removeItem('@jwt');
                                await localStorage.removeItem('@user');
                                await localStorage.removeItem('@rest');
                                await localStorage.removeItem('@uf');
                                await localStorage.removeItem('@internal');
                                await localStorage.removeItem('@suser');
                        this.setState({
                            redirect: true
                        })
                    } catch (e) {
                        console.log(e.data);
                    }
                }
            })
        } catch (error) {
            console.log(error);
        }
    }

    updateInfos() {
        this.postTipoEntrega().then(() => {
            if (this.state.tipo === 2) {
                this.postFixa();
            }
            if (this.state.tipo === 3) {
                //this.postBairros().then(() => this.setState({ saved: false }));
                this.verifyBairros()
            }
            if (this.state.tipo === 4) {
                this.postDistancia().then(() => this.setState({ saved: false }));
            }
        })
    }

    handleInputDistancia(event, id) {
        let {km} = this.state;
        var valor = event.target.value;
        var formatValue = valor.split(' ');
        var formated = formatValue[1]?.replace(/,/g, '.');
        try {
            for (let i = 0; i < km.length; i++) {
                if (id === km[i].id) {
                    km[i].valor = String(Number(formated).toFixed(2))
                }
            }
            this.setState({ km, saved: true });
        } catch (error) {
            console.log(error);
        }
    }

    async deleteItem(id) {
        let {km} = this.state;
        for (let i = 0; i < km.length; i++) {
            if (id === km[i].id) {
                km.splice(i, 1)
            }
        }
        this.setState({ km, saved: true });
    }

    async postDistancia() {
        try {
            await api.post('api/restauranteconfigs/createdistancia', {
                taxas: this.state.km
            }, {
                headers: {
                    Authorization: `Bearer ${this.state.token}`
                }
            }).then(async res => {
                this.success()
            }).catch(async e => {
                this.error();
                if (e.response.status === 401) {
                    try {
                        await localStorage.removeItem('@username');
                                await localStorage.removeItem('@jwt');
                                await localStorage.removeItem('@user');
                                await localStorage.removeItem('@rest');
                                await localStorage.removeItem('@uf');
                                await localStorage.removeItem('@internal');
                                await localStorage.removeItem('@suser');
                        this.setState({
                            redirect: true
                        })
                    } catch (e) {
                        console.log(e.data);
                    }
                }
            })
        } catch (error) {
            console.log(error);
        }
    }

    createNewObj() {
        let {km} = this.state;
        km.push({
            id: Number(uniqueId()),
            distancia: "20.00",
            valor: "0.00"
        });
        this.setState({ km, saved: true });
    }

    async setKm(id, valor) {
        let {km} = this.state;
        try {
            for (let i = 0; i < km.length; i++) {
                if (id === km[i].id) {
                    km[i].distancia = valor
                }
            }
            this.selectModal(this.state.selectOpen);
            this.setState({ saved: true });
        } catch (error) {
            console.log(error);
        }
    }

    async setFiltro(filtro) {
        this.setState({
            filtro
        });
        this.filtroModal(this.state.filtroOpen)
    }

    renderFilter(item, filtro) {
        let vals = item.record;
        function compare( a, b ) {
            if (filtro === 0) {
                if(a.nome < b.nome) { return -1; }
                if(a.nome > b.nome) { return 1; }
            }
            if (filtro === 1) {
                if (!a.ativo && b.ativo){
                    return 1;
                  } else {
                      return -1
                  }
            } 
            if (filtro === 2) {
                if (a.ativo && !b.ativo){
                    return 1;
                  } else {
                      return -1
                  }
            } 
            if (filtro === 3) {
                if ( Number(a.valor) < Number(b.valor) ){
                    return 1;
                  }
                  if ( Number(a.valor) > Number(b.valor) ){
                    return -1;
                  }
            } 

            if(filtro === 4) {
                if ( Number(a.valor) < Number(b.valor) ){
                    return -1;
                  }
                  if ( Number(a.valor) > Number(b.valor) ){
                    return 1;
                  }
            }
            return 0;
          }
          vals.sort(compare);

            if (this.state.windowWidth > 691) {
                return vals.map(item2 => (
                    <tr
                        key={item2.id}>
                        <td 
                            onClick={
                                () => this.state.superUser ? 
                                    this.state.permission === 2 ? this.handleModalBairro(this.state.isOpen, item2.id, item.alphabet, item2.valor) : null 
                                    : this.handleModalBairro(this.state.isOpen, item2.id, item.alphabet, item2.valor)
                                }>{item2.nome}</td>
                        <td 
                            onClick={
                                () => this.state.superUser ? 
                                    this.state.permission === 2 ? this.handleModalBairro(this.state.isOpen, item2.id, item.alphabet, item2.valor) : null 
                                    : this.handleModalBairro(this.state.isOpen, item2.id, item.alphabet, item2.valor)
                            }
                            style={item2.ativo ? {fontWeight: 550} : {fontWeight: 'normal'} }>{`R$ ${(item2.valor).replace(".", ",")}`}</td>
                        <td>
                            <label className="aberto-fechado">
                                <Switch
                                    onChange={
                                        () => this.state.superUser ? 
                                    this.state.permission === 2 ? this.handleSwitch(item, item2) : null 
                                    : this.handleSwitch(item, item2)
                                    }
                                    defaultChecked={item2.ativo}
                                    checked={item2.ativo}
                                />
                                <h4>{item2.ativo ? 'Entrega ativada' : 'Entrega desativada'}</h4>
                            </label>
                        </td>
                    </tr>
                  ))
            } else {
                return vals.map(item2 => (
                    <tr className="tr__mobile" key={item2.id}>
                        <thead>
                            <th style={{paddingTop: 56}}>Bairro</th>
                        </thead>
                        <tbody>
                            <td>{item2.nome}</td>
                        </tbody>
                        <thead>
                            <th>Valor</th>
                        </thead>
                        <tbody>
                            <td onClick={
                                () => this.state.superUser ? 
                            this.state.permission === 2 ? this.handleModalBairro(this.state.isOpen, item2.id, item.alphabet, item2.valor) : null 
                            : this.handleModalBairro(this.state.isOpen, item2.id, item.alphabet, item2.valor)
                                }>{`R$ ${(item2.valor).replace(".", ",")}`}</td>
                        </tbody>
                        <thead>
                            <th>Ação</th>
                        </thead>
                        <tbody>
                            <td style={{paddingBottom: 56}}>
                                <label className="aberto-fechado">
                                    <Switch
                                        onChange={
                                            () => this.state.superUser ? 
                            this.state.permission === 2 ? this.handleSwitch(item, item2) : null 
                            : this.handleSwitch(item, item2)
                                        }
                                        defaultChecked={item2.ativo}
                                        checked={item2.ativo}
                                    />
                                    <h4>{item2.ativo ? 'Entrega ativada' : 'Entrega desativada'}</h4>
                                </label>
                            </td>
                        </tbody>
                    </tr>
                  ))
            }
    }

    kmMap(array) {
        let vals = array;

        function compare(a, b) {
            if ( Number(a.distancia) < Number(b.distancia) ){
                return -1;
              }
              if ( Number(a.distancia) > Number(b.distancia) ){
                return 1;
              }
        }

        vals.sort(compare)

        function renderKm(item) {
            return `até ${(`${Number(item.distancia)}`).replace(".", ",")}km`
        }

        const openSelect = (id) => {
            this.setState({ idDistancia: id });
            this.selectModal(this.state.selectOpen);
        }

        return vals.map(item => (
                <div key={item.id}>
                    <div className="div-input" onClick={
                        () => this.state.superUser ? 
                                    this.state.permission === 2 ? openSelect(item.id) : null 
                                    : openSelect(item.id)
                    }>
                            <input
                                value={renderKm(item)}
                                name="valor"
                                type="text"
                                required
                                style={{
                                    caretColor: 'transparent'
                                }}
                                />
                            <label htmlFor="" className="label-name">
                                <span className="content-name">Escolha uma distância</span>
                            </label>
                    </div>
                    
                    <div className="div-input">
                        <CurrencyInput
                            inputType="text"
                            maxLength="9"
                            name="valor1"
                            prefix="R$ "
                            onFocus={() => {
                                this.setState({
                                    valorClass1: 'div-input-focado'
                                })
                            }}
                            onBlur={() => {
                                this.setState({
                                    valorClass1: 'div-input'
                                })
                            }}
                            required
                            decimalSeparator=","
                            value={item.valor}
                            onChangeEvent={
                                (e) => this.state.superUser ? 
                                    this.state.permission === 2 ? this.handleInputDistancia(e, item.id) : null 
                                    : this.handleInputDistancia(e, item.id)
                            }
                        />
                        <label htmlFor="" className="label-name">
                            <span className="content-name">Digite o valor</span>
                        </label>
                    </div>
                {this.state.superUser ? (
                                this.state.permission === 2 ? (
                                    <div className="botao-inside">
                                        <button
                                            className="salvar-branco" 
                                            onClick={() => this.deleteItem(item.id)}>Excluir distância</button>
                                    </div>
                                ) : null
                            ) : (
                                <div className="botao-inside">
                                    <button
                                        className="salvar-branco" 
                                        onClick={() => this.deleteItem(item.id)}>Excluir distância</button>
                                </div>
                            )}
                <hr className="linha-distancia"/>
                </div>
            )
        )
    }

    toggleEntrega(tipo) {
        switch (tipo) {
            case 0:
                this.setState({ entrega_gratis: false, saved: true });
                break;
            case 1:
                this.setState({ entrega_gratis: true, saved: true });
                break;
            default:
                break;
        }
    }

    renderFilterMobile(item, filtro) {
        let vals = item.record;
        function compare( a, b ) {
            if (filtro === 0) {
                if(a.nome < b.nome) { return -1; }
                if(a.nome > b.nome) { return 1; }
            }
            if (filtro === 1) {
                if (!a.ativo && b.ativo){
                    return 1;
                  } else {
                      return -1
                  }
            } 
            if (filtro === 2) {
                if (a.ativo && !b.ativo){
                    return 1;
                  } else {
                      return -1
                  }
            } 
            if (filtro === 3) {
                if ( Number(a.valor) < Number(b.valor) ){
                    return 1;
                  }
                  if ( Number(a.valor) > Number(b.valor) ){
                    return -1;
                  }
            } 

            if(filtro === 4) {
                if ( Number(a.valor) < Number(b.valor) ){
                    return -1;
                  }
                  if ( Number(a.valor) > Number(b.valor) ){
                    return 1;
                  }
            }
            return 0;
          }
          vals.sort(compare);

          return vals.map(item2 => (
              <this.MyComponent
                id={item2.id}
                bairro={item2.nome}
                valor={item2.valor}
                letra={item.alphabet}
                ativo={item2.ativo}
                item={item}
                item2={item2}
              />
            //   <div className="div__mobile__over">
            // <div className="div__mobile" key={item2.id}>
            //         <span className="head">Bairro</span>
            //         <div className="body-div">
            //             <span className="body">{item2.nome}</span>
            //         </div>
            //         <span className="head">Valor</span>
            //         <div 
            //             className="body-div"
            //             onClick={() => this.handleModalBairro(this.state.isOpen, item2.id, item.alphabet, item2.valor)}>
            //             <span className="body" 
            //             style={item2.ativo ? {fontWeight: 550} : {fontWeight: 'normal'} }>{`R$ ${(item2.valor).replace(".", ",")}`}</span>
            //         </div>
            //         <span className="head">Ação</span>
            //         <div className="body-div">
            //             <label className="aberto-fechado">
            //                 <Switch
            //                     onChange={() => this.handleSwitch(item, item2)}
            //                     defaultChecked={item2.ativo}
            //                     checked={item2.ativo}
            //                 />
            //                 <h4>{item2.ativo ? 'Entrega ativada' : 'Entrega desativada'}</h4>
            //             </label>
            //         </div>
            // </div>
            //     <hr/>
            //     </div>
        ))
    }

    //verifica se há algum bairro ativo antes de salvar
    verifyBairros(){
        let novos = [];
            const {bairros} = this.state;
            for (let i = 0; i < bairros.length; i++) {
                for (let j = 0; j < bairros[i].record.length; j++) {
                    if (bairros[i].record[j].ativo === true) {
                        novos.push(bairros[i].record[j])
                    }
                }
            }
            if(novos.length > 0){
                this.postBairros().then(() => this.setState({ saved: false }));
            } else {
                this.customError('Não há bairros ativados, por favor ative pelo menos um.')
            }
    }

    MyComponent = ({ id, bairro, valor, letra, ativo, item, item2 }) => {

        const [isOpen, setIsOpen] = useState(false);
         
        return (
          <div className="div__mobile__over">
            <div className="div__mobile" key={id}>
                <DivAccordion 
                    open={isOpen}
                    onClick={() => setIsOpen(!isOpen)}>
                    <div>
                        <span className="head">Bairro</span>
                        <div className="body-div">
                            <span className="body">{bairro}</span>
                        </div>
                    </div>
                    <div className="icon">
                        <FiChevronDown color={'#000000'} size={24} className="chevron"/>
                    </div>
                </DivAccordion>
                    <Collapse transition={'height 280ms cubic-bezier(0.4, 0, 0.2, 1)'} isOpen={isOpen}>
                    <span className="head">Valor</span>
                    <div 
                        className="body-div"
                        onClick={
                            () => this.state.superUser ? 
                        this.state.permission === 2 ? this.handleModalBairro(this.state.isOpen, id, letra, valor) : null 
                        : this.handleModalBairro(this.state.isOpen, id, letra, valor)
                            }>
                        <span className="body" 
                        style={ativo ? {fontWeight: 550} : {fontWeight: 'normal'} }>{`R$ ${(valor).replace(".", ",")}`}</span>
                    </div>
                    <span className="head">Ação</span>
                    <div className="body-div">
                        <label className="aberto-fechado">
                            <Switch
                                onChange={
                                    () => this.state.superUser ? 
                        this.state.permission === 2 ? this.handleSwitch(item, item2) : null 
                        : this.handleSwitch(item, item2)
                                }
                                defaultChecked={ativo}
                                checked={ativo}
                            />
                            <h4>{ativo ? 'Entrega ativada' : 'Entrega desativada'}</h4>
                        </label>
                    </div>
                    </Collapse>
            </div>
                <hr/>
                </div>
      )};

      renderAlphabet = ({ item }) => {

        const [isOpen, setOpen] = useState(true);

        return (
            <div
                key={item.alphabet} 
                className="ordem-alfabetica">
                    <DivAlphabet 
                        open={isOpen}
                        onClick={() => setOpen(!isOpen)} >
                        <span 
                        className="letra">{item.alphabet}</span>
                        {this.state.windowWidth > 691 ? (
                            null
                        ) : (
                            <div className="icon">
                                <FiChevronDown color={'#a49b9b'} size={24} className="chevron"/>
                            </div>
                        )}
                    </DivAlphabet>
                {this.state.windowWidth > 691 ? 
                <table>
                    <thead>
                        <tr>
                            <th>Bairro</th>
                            <th>Valor</th>
                            <th>Ação</th>
                        </tr>
                    </thead>
                    
                    <tbody>
                        {this.renderFilter(item, this.state.filtro)}
                    </tbody>

                </table>
                : 
                <Collapse
                style={this.state.windowWidth > 360 ? {marginLeft: -32, marginRight: -32, paddingLeft: 32, paddingRight: 32 } : {marginLeft: -16, marginRight: -16, paddingLeft: 16, paddingRight: 16 }}
                transition={'height 280ms cubic-bezier(0.4, 0, 0.2, 1)'} 
                isOpen={isOpen}>
                    <div style={{paddingTop: 56}}>
                        <hr/>
                        {this.renderFilterMobile(item, this.state.filtro)}
                    </div>
                </Collapse>
                }
            </div>
        )
      }

    render() {
        if (this.state.redirect) {
            return <Redirect to="/login"/>
        }
        return(
            this.state.superUser && this.state.permission === 0 ? (
                <Container>
                    <h1 style={{
                        fontFamily: 'Montserrat',
                        fontSize: 18,
                        fontWeight: 600
                    }}>Você não possui permissão para visualizar esta página.</h1>
                </Container>
            ) : (
            <Container>
                <ToastContainer limit={1} />
                <Modal
                    isOpen={this.state.isOpen}
                    // onAfterOpen={this.controllerModal(this.state.isOpen)}
                    onRequestClose={() => this.controllerModal(this.state.isOpen)}
                    closeModal={() => this.controllerModal(this.state.isOpen)}
                    shouldCloseOnEsc={true}
                    shouldCloseOnOverlayClick={true}
                    closeTimeoutMS={100}
                    style={this.state.windowWidth > 784 ? customStyles : filtroStylesMob}
                    contentLabel="Modal"
                    >
                        <BairroModal
                            idBairro={this.state.idBairro}
                            letraBairro={this.state.letraBairro}
                            valorBairro={this.state.valorBairro}
                            salvar={(id, letra, valor) => this.setValorBairro(id, letra, valor)}
                            closeModal={() => this.controllerModal(this.state.isOpen)}/>
                </Modal>
                <Modal
                    isOpen={this.state.filtroOpen}
                    // onAfterOpen={this.controllerModal(this.state.isOpen)}
                    onRequestClose={() => this.filtroModal(this.state.filtroOpen)}
                    closeModal={() => this.filtroModal(this.state.filtroOpen)}
                    shouldCloseOnEsc={true}
                    shouldCloseOnOverlayClick={true}
                    closeTimeoutMS={100}
                    style={this.state.windowWidth > 784 ? filtroStyles : filtroStylesMob}
                    contentLabel="Modal"
                    >
                        <FiltroModal
                            filtro={this.state.filtro}
                            salvar={(filtro) => this.setFiltro(filtro)}
                            closeModal={() => this.filtroModal(this.state.filtroOpen)}/>
                </Modal>
                <Modal
                    isOpen={this.state.selectOpen}
                    // onAfterOpen={this.controllerModal(this.state.isOpen)}
                    onRequestClose={() => this.selectModal(this.state.selectOpen)}
                    closeModal={() => this.selectModal(this.state.selectOpen)}
                    shouldCloseOnEsc={true}
                    shouldCloseOnOverlayClick={true}
                    closeTimeoutMS={100}
                    style={this.state.windowWidth > 930  ? entrada : mobile}
                    contentLabel="Modal"
                    >
                            <ModalSelect
                                id={this.state.idDistancia}
                                array={this.state.km}
                                selecionar={(id, valor) => this.setKm(id, valor)}
                                closeModal={() => this.selectModal(this.state.selectOpen)}/>
                </Modal>
            {this.state.carregou && (
            <div className="div-pai">
                <div className="div-rota">

                <Link 
                    style={{ textDecoration: 'none' }}
                    to={'/'}>
                    <span
                        className="rotas" >
                        Início
                    </span>
                </Link>

                <span className="rotas"> {'>'} </span>

                <Link 
                    style={{ textDecoration: 'none' }}
                    to={'/configuracoes'}>
                    <span
                        className="rotas" >
                        Configurações
                    </span>
                </Link>

                <span className="rotas"> {'>'} </span>

                <Link 
                    style={{ textDecoration: 'none' }}
                    to={'/configuracoes/entrega'}>
                    <span>
                        Entrega
                    </span>
                </Link>

                </div>

                <div className="titulo">

                <img alt="" className="emoji" src={Entrega} />

                <h1>Entrega</h1>

                <h5>Configure as taxas de entrega do seu restaurante.</h5>

                </div>                

                <Atencao open={this.state.alerta}>
                    <div className="box" 
                        //onClick={() => this.setState({alerta: !this.state.alerta})}
                    >
                        <div className="left">
                            <img alt="" src={Alerta} className="alerta"/>
                            <h5>Atenção</h5>
                        </div>
                        {/* <FiChevronDown color={'#000000'} size={24} className="chevron"/> */}
                    </div>

                    {/* { this.state.alerta ?  */}
                    <div className="textos">
                        <h5>É expressamente proibida a divulgação de números <p>de telefone dentro do aplicativo.</p></h5>
                    </div>
                    <div className="textos-mobile">
                        <h5>É expressamente proibida a divulgação de números de telefone dentro do aplicativo.</h5>
                    </div>
                    {/* : null} */}
                </Atencao>

                <hr className="linha-titulo"/>

                <div className="taxa-entrega">
                    <h2>Taxa de entrega</h2>
                    <h5>Qual a sua taxa de entrega?</h5>

                    <div className="options">
                        <div onClick={
                            () => this.setState({ tipo: 1, saved: true })
                        }
                            className={this.state.tipo === 1 ? 'option-selected' : 'option'}>
                            <span>Não cobro taxa de entrega</span>
                        </div>
                        <div onClick={
                            () => this.setState({ tipo: 2, saved: true })
                        }
                            className={this.state.tipo === 2 ? 'option-selected' : 'option'}>
                            <span>Cobro um valor fixo</span>
                        </div>
                        <div onClick={
                            () => this.setState({ tipo: 3, saved: true })
                        }
                            className={this.state.tipo === 3 ? 'option-selected' : 'option'}>
                            <span>Cobro por bairro</span>
                        </div>
                        <div onClick={
                            () => this.setState({ tipo: 4, saved: true })
                        }
                            className={this.state.tipo === 4 ? 'option-selected' : 'option'}>
                            <span>Cobro por distância (Km)</span>
                        </div>
                    </div>
                </div>

                {this.state.tipo === 4 && (
                    <>
                    <hr className="linha"/>
                    <div className="taxa-entrega">
                        <h2>Qual a distância e o valor para entrega?</h2>
                        <h5>Digite os valores de acordo com as distâncias.</h5>

                        <div>
                        {this.kmMap(this.state.km)}
                        </div>

                    </div>
                    
                    {this.state.superUser ? (
                                this.state.permission === 2 ? (
                                    <div className="botao">
                                        <button
                                            className="salvar-branco" 
                                            onClick={() => this.createNewObj()}>Adicionar nova distância</button>
                                    </div>
                                ) : null
                            ) : (
                                <div className="botao">
                                    <button
                                        className="salvar-branco" 
                                        onClick={() => this.createNewObj()}>Adicionar nova distância</button>
                                </div>
                            )}
                    </>
                )}

                {this.state.tipo === 3 && (
                    <>
                    <hr className="linha"/>
                    <div className="taxa-entrega">
                        <h2>Bairros de {this.state.rest.cidade.nome}</h2>
                        <h5>Para configurar o preço da taxa de entrega e incluir o bairro na área de cobertura, 
<p>digite o valor a ser cobrado, aperte o botão de entrega e salve as alterações.</p></h5>

                    <Filtro open={this.state.filtroOpen}>
                        <div className="box" onClick={() => this.filtroModal(this.state.filtroOpen)}>
                            <div className="left">
                                <h5>{this.state.filtro === 1 ? 'Bairros que você entrega' :
                                this.state.filtro === 2 ? 'Bairros que você não entrega' : this.state.filtro === 3 ? 'Taxas mais altas' : this.state.filtro === 4 ? 'Taxas menores' : 'Ordenar resultados'}</h5>
                            </div>
                            <FiChevronDown color={'#000000'} size={24} className="chevron"/>
                        </div>
                    </Filtro>

                    <div className="bairros">
                            {this.state.bairros.map(item => (<this.renderAlphabet item={item} />))}
                    </div>

                    </div>
                    </>
                )}

                    {this.state.tipo === 2 && (
                        <>
                    <hr className="linha"/>
                        <div className="taxa-entrega">
                            <h2>Qual valor?</h2>
                            <h5>Escolha um valor para a taxa de entrega</h5>

                            <div className={this.state.valorClass1}>
                                    <CurrencyInput
                                        inputType="text"
                                        maxLength="9"
                                        name="valor1"
                                        prefix="R$ "
                                        onFocus={() => {
                                            this.setState({
                                                valorClass1: 'div-input-focado'
                                            })
                                        }}
                                        onBlur={() => {
                                            this.setState({
                                                valorClass1: 'div-input'
                                            })
                                        }}
                                        required
                                        decimalSeparator=","
                                        value={this.state.valor1}
                                        onChangeEvent={
                                            (e) => this.state.superUser ? 
                                    this.state.permission === 2 ? this.handleInputs(e) : null 
                                    : this.handleInputs(e)
                                        }
                                    />
                                    <label htmlFor="" className="label-name">
                                        <span className="content-name">Digite um valor</span>
                                    </label>
                            </div>
                        </div>

                    <hr className="linha"/>

                        <div className="taxa-entrega">
                            <h2>Entrega grátis?</h2>
                            <h5>Tem entrega grátis se o cliente comprar acima de algum valor?</h5>

                            <div className="options">
                                <div onClick={
                                    () => this.state.superUser ? 
                                    this.state.permission === 2 ? this.toggleEntrega(0) : null 
                                    : this.toggleEntrega(0)
                                }
                                    name="nao"
                                    className={!this.state.entrega_gratis ? 'option-selected' : 'option'}>
                                    <span>Não</span>
                                </div>
                                <div onClick={
                                    () => this.state.superUser ? 
                                    this.state.permission === 2 ? this.toggleEntrega(1) : null 
                                    : this.toggleEntrega(1)
                                }
                                    name="sim"
                                    className={this.state.entrega_gratis ? 'option-selected' : 'option'}>
                                    <span>Sim</span>
                                </div>
                            </div>
                        </div>

                        {this.state.entrega_gratis && (
                            <>
                            <hr className="linha"/>
                            <div className="taxa-entrega">
                                <h2>Qual valor?</h2>
                                <h5>Escolha um valor para a taxa de entrega</h5>

                                <div className={this.state.valorClass2}>
                                        <CurrencyInput
                                            inputType="text"
                                            maxLength="9"
                                            name="valor2"
                                            prefix="R$ "
                                            onFocus={() => {
                                                this.setState({
                                                    valorClass2: 'div-input-focado'
                                                })
                                            }}
                                            onBlur={() => {
                                                this.setState({
                                                    valorClass2: 'div-input'
                                                })
                                            }}
                                            required
                                            decimalSeparator=","
                                            value={this.state.valor2}
                                            onChangeEvent={
                                                (e) => this.state.superUser ? 
                                    this.state.permission === 2 ? this.handleInputs(e) : null 
                                    : this.handleInputs(e)
                                            }
                                        />
                                        <label htmlFor="" className="label-name">
                                            <span className="content-name">Digite um valor mínimo</span>
                                        </label>
                                </div>
                            </div>
                            </>
                        )}
                        </>
                    )}

                    {this.state.superUser ? (
                                this.state.permission === 2 ? (
                                    this.state.saved && (
                                        <div className="botao">
                                    <button
                                        className="salvar" 
                                        onClick={() => {this.updateInfos()}}>Salvar alterações</button>
                                    </div>
                                    ) 
                                ) : null
                            ) : (
                                this.state.saved && (
                                    <div className="botao">
                                <button
                                    className="salvar" 
                                    onClick={() => {this.updateInfos()}}>Salvar alterações</button>
                                </div>
                                ) 
                            )}
            </div>
            )}
            </Container>
        ))
    }
}
